import React, { useEffect, useState } from "react";
import { Github, Linkedin, Heart, ArrowUp } from "lucide-react";
import { endpoints } from "../../lib/api";
export default function Footer({ config }) {
    const [visitors, setVisitors] = useState(null);
    useEffect(() => { endpoints.visitors().then((d) => setVisitors(d.count)).catch(() => { }); }, []);
    return (
        <footer className="relative border-t border-border mt-10" data-testid="footer">
            <div className="max-w-6xl mx-auto px-5 py-16">
                <div className="flex flex-col md:flex-row justify-between gap-10">
                    <div>
                        <div className="font-display text-4xl sm:text-5xl font-semibold mb-4">Let&apos;s build<br />something <span className="aurora-text">great</span>.</div>
                        <div className="flex gap-3">
                            <a data-testid="footer-github" href={config?.socials?.github || "https://github.com/hariompatel61"} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center glass rounded-full hover:text-primary transition-colors"><Github className="w-4 h-4" /></a>
                            <a data-testid="footer-linkedin" href={config?.socials?.linkedin || "https://www.linkedin.com/in/hariompatel069/"} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center glass rounded-full hover:text-primary transition-colors"><Linkedin className="w-4 h-4" /></a>
                        </div>
                    </div>
                    <div className="flex flex-col items-start md:items-end gap-3">
                        <button data-testid="footer-back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
                            Back to top <ArrowUp className="w-4 h-4" />
                        </button>
                        <div className="font-mono text-xs text-muted-foreground" data-testid="visitor-counter">
                            {visitors !== null ? `${visitors.toLocaleString()} visitors` : "…"}
                        </div>
                    </div>
                </div>
                <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted-foreground">
                    <div>© {new Date().getFullYear()} {config?.name}. All rights reserved.</div>
                    <div className="flex items-center gap-1.5">Built with <Heart className="w-3 h-3 text-red-500 fill-red-500" /> using React · FastAPI · MongoDB</div>
                </div>
            </div>
        </footer>
    );
}
